import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { getProductStockHistoryList } from '../../../services/ProductService';
import Pagination from '../../constant/Pagination';
import StockHistoryTypeBadge from '../../constant/StockHistoryTypeBadge';

const ProductHistory = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [data, setData] = useState([])
    const [product, setProduct] = useState(null)
    const [total, setTotal] = useState(0)
    const recordsPage = 10;

    useEffect(() => {
        getProductStockHistoryList(id, currentPage, recordsPage, '').then((resp) => {
            const { total, product, data } = resp.data
            setData(data)
            setTotal(total)
            setProduct(product)
        }).catch((error) => {
            console.log(error.response.data.message)
        })

    }, [id])

    const handlePagination = (page) => {
        const new_page = page.selected + 1
        getProductStockHistoryList(id, new_page, recordsPage, '').then((resp) => {
            const { total, product, data } = resp.data
            setData(data)
            setTotal(total)
            setProduct(product)
            setCurrentPage(new_page)
        }).catch((error) => {
            alert(error.response.data.message)
        })
    }

    const handleSearchChange = (e) => {
        const { value } = e.target
        getProductStockHistoryList(id, currentPage, recordsPage, value).then((resp) => {
            const { total, product, data } = resp.data
            setData(data)
            setTotal(total)
            setProduct(product)
        }).catch((error) => {
            console.log(error.response.data.message)
        })
        setSearchQuery(value)
    }


    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <div className="d-flex align-items-center">
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary btn-sm rounded-circle"
                                                style={{ padding: "5px 9px" }}
                                                onClick={() => navigate(`/material/${id}`)}
                                            ><i className="fa-solid fa-arrow-left"></i></button>
                                            <h4 className="mb-0 ms-2">Stock History of Material <span className='fw-bolder'>{product?.name}</span></h4>
                                        </div>
                                        <div className='d-flex'>
                                            <div className='form-group me-5'>
                                                <input type="search" name="serach" className="form-control "
                                                    placeholder="Search"
                                                    value={searchQuery} onChange={handleSearchChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Rack</th>
                                                    <th>User</th>
                                                    <th>Quantity</th>
                                                    <th>Product Quantity</th>
                                                    <th>Employee</th>
                                                    <th>Source / Purpose</th>
                                                    <th>Status</th>
                                                    <th>Barcode</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td><span>{item.stock.rack ? <Link to={`/rack/${item.stock.rack.id}`}>{item.stock.rack.rack_no}</Link> : null}</span></td>
                                                        <td><span>{item.user.name}</span></td>
                                                        <td>
                                                            <span>{item.quantity}</span>
                                                        </td>
                                                        <td>
                                                            <span>{item.product_quantity}</span>
                                                        </td>
                                                        <td>
                                                            <span>{item?.employee?.name || ""}</span>
                                                        </td>
                                                        <td>
                                                            <span>
                                                                {item.source ? item.source : item?.purpose ? (
                                                                    <small className="px-2 py-1 text-bg-light border border-light rounded-2">{item.purpose}</small>
                                                                ) : ""}
                                                            </span>

                                                        </td>
                                                        <td>
                                                            {item.is_stock_out ? (
                                                                <span className={`badge light border-0 badge-danger`}>OUT</span>
                                                            ) : (
                                                                <span className={`badge light border-0 badge-success`}>IN</span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <span>{item.stock.barcode_no}</span>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex flex-column">
                                                                <span>{item.created_at}</span>
                                                                <div>
                                                                    <StockHistoryTypeBadge historyType={item.history_type} />
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                        <Pagination
                                            currentPage={currentPage}
                                            recordsPage={recordsPage}
                                            dataLength={total}
                                            handlePagination={handlePagination}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default ProductHistory;